// Danh sách tổ dân phố (fake data) - port từ bản HTML gốc
export const TDP_NAMES = [
  "Nam Đội Cung",
  "Bắc Đội Cung",
  "Ngô Quyền",
  "Điện Biên",
  "Phan Bội Châu",
  "Lê Văn Hưu",
  "Phan Bội Châu 4",
  "Thống Nhất 1",
  "Thống Nhất 2",
  "Phan Bội Châu 1",
  "Nam Thành",
  "Nam Cao",
  "Phú Thọ 2",
  "Tây Sơn 2",
  "Phú Thọ 1",
  "Tây Sơn 1",
  "Tây Sơn 3",
  "Phú Thọ 3",
  "Trần Phú",
  "Tây Ga",
  "Trường Thi",
  "Bà Triệu",
  "TDP Đàm",
  "Thắng",
  "Nam",
  "Trung",
  "Bắc",
  "Đội Cung 4",
  "Đội Cung 4B",
  "Lợi 1",
  "Lợi 2",
  "Đội Cung 1",
  "Đội Cung 2",
  "Đông Bắc Ga 2",
  "Đông Bắc Ga 1",
  "Đông Thọ",
  "Bắc Thành",
  "Dương Đình Nghệ 1",
  "Dương Đình Nghệ 2",
  "Tân Lập",
  "Hoà Bình",
  "Tô Vĩnh Diện",
  "Đông Lân",
  "Nguyễn Du",
  "Triệu Quốc Đạt",
  "Lê Hoàn",
  "Hàng Đồng",
  "Lam Sơn",
  "Phú Thọ 4",
  "Tây Sơn 4",
  "Hậu Thành",
];

export const TDP_LIST = TDP_NAMES.map((name, i) => ({
  id: i + 1,
  name,
  label: `TDP ${i + 1} – ${name}`,
}));

export const HOUSE_NUMBER_RULE_TYPE = {
  DUONG: "DUONG",
  NGO: "NGO",
  MB: "MB",
  CC: "CC",
};

export const HOUSE_NUMBER_RULE_SIDE = {
  CHAN: "CHAN",
  LE: "LE",
  CA_HAI: "CA_HAI",
  TAT_CA: "TAT_CA",
};

export const RULE_TYPE_OPTIONS = [
  { value: HOUSE_NUMBER_RULE_TYPE.DUONG, label: "Đường / Phố" },
  { value: HOUSE_NUMBER_RULE_TYPE.NGO, label: "Nhà trong ngõ" },
  { value: HOUSE_NUMBER_RULE_TYPE.MB, label: "Mặt bằng / LK" },
  { value: HOUSE_NUMBER_RULE_TYPE.CC, label: "Chung cư / Tòa" },
];

export const HOUSE_NUMBER_SIDE_OPTIONS = [
  { value: HOUSE_NUMBER_RULE_SIDE.CHAN, label: "Chẵn" },
  { value: HOUSE_NUMBER_RULE_SIDE.LE, label: "Lẻ" },
  { value: HOUSE_NUMBER_RULE_SIDE.CA_HAI, label: "Cả hai" },
];

export const HOUSE_NUMBER_STREET_SIDE_OPTIONS = [
  ...HOUSE_NUMBER_SIDE_OPTIONS,
  { value: HOUSE_NUMBER_RULE_SIDE.TAT_CA, label: "Toàn đường" },
];

export const HOUSE_NUMBER_MB_MODE_OPTIONS = [
  { value: "all", label: "Toàn bộ mặt bằng" },
  { value: "range", label: "Theo lô (tiền tố + range)" },
];

export const HOUSE_NUMBER_MB_PAD_OPTIONS = [
  { value: "pad", label: "Có đệm 0 (01, 02)" },
  { value: "nopad", label: "Không đệm (1, 2)" },
];

export const HOUSE_NUMBER_MB_POS_OPTIONS = [
  { value: "after", label: "Số sau tiền tố (LK01)" },
  { value: "before", label: "Số trước tiền tố (01LK)" },
];

export const HOUSE_NUMBER_CC_FMT_OPTIONS = [
  { value: "num", label: "Tiền tố + số (CT1, CT2)" },
  { value: "pad", label: "Tiền tố + đệm 0 (CT01, CT02)" },
  { value: "suf", label: "Số + hậu tố (1A, 2A)" },
  { value: "sufpad", label: "Đệm 0 + hậu tố (01A, 02A)" },
];

const TYPE_ALIASES = {
  duong: HOUSE_NUMBER_RULE_TYPE.DUONG,
  DUONG: HOUSE_NUMBER_RULE_TYPE.DUONG,
  ngo: HOUSE_NUMBER_RULE_TYPE.NGO,
  NGO: HOUSE_NUMBER_RULE_TYPE.NGO,
  mb: HOUSE_NUMBER_RULE_TYPE.MB,
  MB: HOUSE_NUMBER_RULE_TYPE.MB,
  cc: HOUSE_NUMBER_RULE_TYPE.CC,
  CC: HOUSE_NUMBER_RULE_TYPE.CC,
};

const SIDE_ALIASES = {
  "Chẵn": HOUSE_NUMBER_RULE_SIDE.CHAN,
  CHAN: HOUSE_NUMBER_RULE_SIDE.CHAN,
  "Lẻ": HOUSE_NUMBER_RULE_SIDE.LE,
  LE: HOUSE_NUMBER_RULE_SIDE.LE,
  "Cả hai": HOUSE_NUMBER_RULE_SIDE.CA_HAI,
  CA_HAI: HOUSE_NUMBER_RULE_SIDE.CA_HAI,
  "Tất cả": HOUSE_NUMBER_RULE_SIDE.TAT_CA,
  "Toàn đường": HOUSE_NUMBER_RULE_SIDE.TAT_CA,
  TAT_CA: HOUSE_NUMBER_RULE_SIDE.TAT_CA,
};

const TYPE_LABELS = {
  [HOUSE_NUMBER_RULE_TYPE.DUONG]: "Đường",
  [HOUSE_NUMBER_RULE_TYPE.NGO]: "Ngõ",
  [HOUSE_NUMBER_RULE_TYPE.MB]: "Mặt bằng",
  [HOUSE_NUMBER_RULE_TYPE.CC]: "Chung cư",
};

const SIDE_LABELS = {
  [HOUSE_NUMBER_RULE_SIDE.CHAN]: "Chẵn",
  [HOUSE_NUMBER_RULE_SIDE.LE]: "Lẻ",
  [HOUSE_NUMBER_RULE_SIDE.CA_HAI]: "Cả hai",
  [HOUSE_NUMBER_RULE_SIDE.TAT_CA]: "Toàn đường",
};

export const normalizeRuleType = (value) => TYPE_ALIASES[value] || value;

export const normalizeRuleSide = (value) => SIDE_ALIASES[value] || value;

export const normalizeHouseNumberRule = (rule = {}) => {
  const current = rule || {};
  return {
    ...current,
    type: normalizeRuleType(current.type),
    ben: normalizeRuleSide(current.ben),
    ngoBen: normalizeRuleSide(current.ngoBen),
  };
};

export const pad2 = (n) => (n < 10 ? "0" + n : String(n));

// Parse số nhà dạng "1A", "10B", "5", "01A5", "01A53" thành { prefix: "01A", num: 5, suffix: "" }
// Hỗ trợ các dạng:
//   "5"     → { prefix: "", num: 5, suffix: "" }
//   "10B"   → { prefix: "", num: 10, suffix: "B" }
//   "01A5"  → { prefix: "01A", num: 5, suffix: "" }
//   "01A53" → { prefix: "01A", num: 53, suffix: "" }
export const parseHouseNum = (val) => {
  if (val === null || val === undefined || val === "") return null;
  const s = String(val).trim();
  if (!s) return null;

  // Thử match dạng phức tạp: prefix (chữ+số lẫn) + số cuối + suffix chữ cuối (tùy chọn)
  // VD: "01A5" → prefix="01A", num=5, suffix=""
  // VD: "01A53" → prefix="01A", num=53, suffix=""
  // VD: "2B" → prefix="", num=2, suffix="B"
  // VD: "10" → prefix="", num=10, suffix=""

  // Tách phần số cuối cùng và chữ cuối cùng (nếu có)
  const mComplex = s.match(/^(.*?)(\d+)([A-Za-z]*)$/);
  if (!mComplex) return null;

  const prefix = mComplex[1] || "";
  const num = parseInt(mComplex[2], 10);
  const suffix = mComplex[3] || "";

  return { prefix, num, suffix };
};

export const typeLabel = (t) => TYPE_LABELS[normalizeRuleType(t)] || t || "—";

// Sinh ra toàn bộ danh sách địa chỉ cụ thể từ 1 rule
export const genAddresses = (r) => {
  r = normalizeHouseNumberRule(r);
  const a = [];
  if (!r) return a;

  if (r.type === HOUSE_NUMBER_RULE_TYPE.DUONG) {
    const d = r.t3Name || "";
    if (r.ben === HOUSE_NUMBER_RULE_SIDE.TAT_CA) {
      a.push("Toàn bộ đường " + (d || "?"));
      return a;
    }
    const pFrom = parseHouseNum(r.soTu);
    const pTo = parseHouseNum(r.soDen);
    const f = pFrom ? pFrom.num : 0;
    const t = pTo ? pTo.num : 0;
    // Prefix và suffix: nếu cả hai cùng prefix+suffix thì dùng, ngược lại không ghép
    const pPrefix = pFrom && pTo && pFrom.prefix === pTo.prefix ? pFrom.prefix : "";
    const pSuffix = pFrom && pTo && pFrom.suffix === pTo.suffix ? pFrom.suffix : "";
    for (let i = f; i <= t && i > 0; i++) {
      if (r.ben === HOUSE_NUMBER_RULE_SIDE.CHAN && i % 2 !== 0) continue;
      if (r.ben === HOUSE_NUMBER_RULE_SIDE.LE && i % 2 === 0) continue;
      a.push(pPrefix + i + pSuffix + " " + (d || "?"));
    }
  } else if (r.type === HOUSE_NUMBER_RULE_TYPE.NGO) {
    const d = r.t3Name || "";
    const ng = r.ngoSo || "?";
    const ngoMode = r.ngoMode || "range";
    if (ngoMode === "all") {
      a.push("Ngõ " + ng + (d ? " " + d : ""));
      return a;
    }
    const b = r.ngoBen || HOUSE_NUMBER_RULE_SIDE.CA_HAI;
    const f = parseInt(r.ngoTu) || 0;
    const t = parseInt(r.ngoDen) || 0;
    for (let i = f; i <= t && i > 0; i++) {
      if (b === HOUSE_NUMBER_RULE_SIDE.CHAN && i % 2 !== 0) continue;
      if (b === HOUSE_NUMBER_RULE_SIDE.LE && i % 2 === 0) continue;
      a.push(i + "/" + ng + " " + (d || "?"));
    }
  } else if (r.type === HOUSE_NUMBER_RULE_TYPE.MB) {
    const ma = r.mbMa || "?";
    if (r.mbMode === "all") {
      a.push(ma);
      return a;
    }
    const pre = r.mbPre || "";
    const sep = r.mbSep != null ? r.mbSep : "-";
    const pad = r.mbPad || "pad";
    const pos = r.mbPos || "after";
    const f = parseInt(r.mbTu) || 0;
    const t = parseInt(r.mbDen) || 0;
    for (let i = f; i <= t && i > 0; i++) {
      const num = pad === "pad" ? pad2(i) : String(i);
      const lo = pos === "after" ? pre + num : num + pre;
      a.push(lo + (ma ? sep + ma : ""));
    }
  } else if (r.type === HOUSE_NUMBER_RULE_TYPE.CC) {
    const pre = r.ccPre || "";
    const fmt = r.ccFmt || "num";
    const khu = r.t3Name || "";
    const f = parseInt(r.ccTu) || 0;
    const t = parseInt(r.ccDen) || 0;
    for (let i = f; i <= t && i > 0; i++) {
      const toa =
        fmt === "pad"
          ? pre + pad2(i)
          : fmt === "suf"
            ? i + pre
            : fmt === "sufpad"
              ? pad2(i) + pre
              : pre + i;
      if (r.t1On) {
        const f1 = parseInt(r.t1F1) || 1;
        const t1 = parseInt(r.t1F2) || 1;
        const u1 = parseInt(r.t1U1) || 1;
        const u2 = parseInt(r.t1U2) || 1;
        const p = r.t1Pre || "";
        for (let fl = f1; fl <= t1; fl++) {
          for (let u = u1; u <= u2; u++) {
            a.push(toa + "-" + p + fl + pad2(u) + (khu ? " – " + khu : ""));
          }
        }
      } else {
        a.push(toa + (khu ? " – " + khu : ""));
      }
    }
  }
  return a;
};

export const allAddrsOfTdp = (rules) =>
  (rules || []).flatMap((r) => genAddresses(r));

export const streetLabel = (r) => {
  r = normalizeHouseNumberRule(r);
  if (r.type === HOUSE_NUMBER_RULE_TYPE.DUONG) return r.t3Name || "(chưa đặt tên)";
  if (r.type === HOUSE_NUMBER_RULE_TYPE.NGO) return `Ngõ ${r.ngoSo || "?"} – ${r.t3Name || "?"}`;
  if (r.type === HOUSE_NUMBER_RULE_TYPE.MB)
    return r.mbMode === "all"
      ? "Toàn bộ " + (r.mbMa || "?")
      : (r.mbPre || "LK") + "xx – " + (r.mbMa || "?");
  if (r.type === HOUSE_NUMBER_RULE_TYPE.CC)
    return (r.ccPre || "CT") + "xx" + (r.t3Name ? " – " + r.t3Name : "");
  return "?";
};

export const rangeLabel = (r) => {
  r = normalizeHouseNumberRule(r);
  if (r.type === HOUSE_NUMBER_RULE_TYPE.DUONG)
    return r.ben === HOUSE_NUMBER_RULE_SIDE.TAT_CA
      ? "Toàn đường"
      : `${r.soTu || "?"} → ${r.soDen || "?"}`;
  if (r.type === HOUSE_NUMBER_RULE_TYPE.NGO) {
    const ngoMode = r.ngoMode || "range";
    return ngoMode === "all" ? "Toàn ngõ" : `${r.ngoTu || "?"} → ${r.ngoDen || "?"}`;
  }
  if (r.type === HOUSE_NUMBER_RULE_TYPE.MB)
    return r.mbMode === "all"
      ? "Toàn bộ"
      : `${r.mbTu || "?"} → ${r.mbDen || "?"}`;
  if (r.type === HOUSE_NUMBER_RULE_TYPE.CC) return `${r.ccTu || "?"} → ${r.ccDen || "?"}`;
  return "—";
};

export const needsReview = (r) => {
  r = normalizeHouseNumberRule(r);
  if (r.type === HOUSE_NUMBER_RULE_TYPE.DUONG)
    return !r.t3Name || (r.ben !== HOUSE_NUMBER_RULE_SIDE.TAT_CA && (!r.soTu || !r.soDen));
  if (r.type === HOUSE_NUMBER_RULE_TYPE.NGO) {
    const ngoMode = r.ngoMode || "range";
    return !r.ngoSo || (ngoMode === "range" && (!r.ngoTu || !r.ngoDen));
  }
  if (r.type === HOUSE_NUMBER_RULE_TYPE.MB)
    return !r.mbMa || (r.mbMode !== "all" && (!r.mbTu || !r.mbDen));
  if (r.type === HOUSE_NUMBER_RULE_TYPE.CC) return !r.ccPre || !r.ccTu || !r.ccDen;
  return false;
};

export const sideLabel = (r) => {
  r = normalizeHouseNumberRule(r);
  if (r.type === HOUSE_NUMBER_RULE_TYPE.DUONG)
    return SIDE_LABELS[r.ben] || "—";
  if (r.type === HOUSE_NUMBER_RULE_TYPE.NGO)
    return SIDE_LABELS[r.ngoBen] || "—";
  return "—";
};

// Trả về màu tag antd tương ứng (thay cho class CSS s-chan/s-le/...)
export const sideTagColor = (r) => {
  const s = sideLabel(r);
  if (s === "Chẵn") return "blue";
  if (s === "Lẻ") return "green";
  if (s === "Cả hai" || s === "Toàn đường") return "default";
  if (needsReview(r)) return "orange";
  return "default";
};

const COMMON_PAYLOAD_FIELDS = ["type", "t3Name", "note"];
const TYPE_PAYLOAD_FIELDS = {
  [HOUSE_NUMBER_RULE_TYPE.DUONG]: ["ben", "soTu", "soDen"],
  [HOUSE_NUMBER_RULE_TYPE.NGO]: ["ngoSo", "ngoMode", "ngoBen", "ngoTu", "ngoDen"],
  [HOUSE_NUMBER_RULE_TYPE.MB]: [
    "mbMa",
    "mbMode",
    "mbPre",
    "mbSep",
    "mbPad",
    "mbPos",
    "mbTu",
    "mbDen",
  ],
  [HOUSE_NUMBER_RULE_TYPE.CC]: [
    "ccPre",
    "ccFmt",
    "ccTu",
    "ccDen",
    "t1On",
    "t1Pre",
    "t1F1",
    "t1F2",
    "t1U1",
    "t1U2",
  ],
};

const shouldSendField = (key, value) => {
  if (value === undefined || value === null) return false;
  if (typeof value === "string" && value.trim() === "" && key !== "mbSep") {
    return false;
  }
  return true;
};

const normalizePayloadValue = (key, value) =>
  typeof value === "string" && key !== "mbSep" ? value.trim() : value;

export const prepareHouseNumberRulePayload = (rule = {}, extra = {}) => {
  const normalized = normalizeHouseNumberRule(rule);
  const type = normalized.type || HOUSE_NUMBER_RULE_TYPE.DUONG;
  let fields = [...COMMON_PAYLOAD_FIELDS, ...(TYPE_PAYLOAD_FIELDS[type] || [])];

  if (type === HOUSE_NUMBER_RULE_TYPE.DUONG && normalized.ben === HOUSE_NUMBER_RULE_SIDE.TAT_CA) {
    fields = fields.filter((field) => !["soTu", "soDen"].includes(field));
  }

  if (type === HOUSE_NUMBER_RULE_TYPE.NGO && normalized.ngoMode === "all") {
    fields = fields.filter((field) => !["ngoBen", "ngoTu", "ngoDen"].includes(field));
  }

  if (type === HOUSE_NUMBER_RULE_TYPE.MB && normalized.mbMode === "all") {
    fields = fields.filter(
      (field) => !["mbPre", "mbSep", "mbPad", "mbPos", "mbTu", "mbDen"].includes(field),
    );
  }

  if (type === HOUSE_NUMBER_RULE_TYPE.CC && !normalized.t1On) {
    fields = fields.filter(
      (field) => !["t1Pre", "t1F1", "t1F2", "t1U1", "t1U2"].includes(field),
    );
  }

  const payload = {};
  fields.forEach((key) => {
    const value = normalizePayloadValue(key, normalized[key]);
    if (shouldSendField(key, value)) {
      payload[key] = value;
    }
  });

  Object.entries(extra).forEach(([key, value]) => {
    const nextValue = normalizePayloadValue(key, value);
    if (shouldSendField(key, nextValue)) {
      payload[key] = nextValue;
    }
  });

  return payload;
};
